import { isValidElement, ReactElement } from 'react';

import TabItem, { TabItemProps } from './TabItem';

export type TabNavProps = {
  /** Receives components of type TabItem v2 */
  children: ReactElement<TabItemProps> | ReactElement<TabItemProps>[];
};

const TabNav = ({ children }: TabNavProps) => {
  if (!Array.isArray(children)) {
    children = [children];
  }

  for (const child of children) {
    if (!isValidElement(child) || child.type !== TabItem) {
      throw new Error('the "children" in TabNav prop only accepts components of type TabItem v2');
    }
  }

  return (
    <div className="relative w-full">
      <ul className="text-sm border-text-center flex flex-wrap font-medium text-emblue-text  ">
        {children}
      </ul>
    </div>
  );
};

export default TabNav;
